import * as types from "./types";

const mutations = {
    [types.LOADING_REPORT](state, value) {
        state.loading = value;
    },
    [types.GET_SALESREPORT](state, sales) {
        state.sales = sales;
    },
    [types.GET_FINISHED](state, finished) {
        state.finished = finished;
    },
    [types.GET_SEMI_FINISHED](state, semi) {
        state.semi = semi;
    },
    [types.GET_RAW](state, raw) {
        state.raw = raw;
    },
    [types.GET_COST](state, cost) {
        state.cost = cost;
    },
    [types.GET_PRODUCTION](state, production) {
        state.production = production;
    },
    [types.GET_LEADTIME](state, lead) {
        state.lead = lead;
    },
    [types.GET_LEAD_CONVERSION](state, conversion) {
        state.conversion = conversion;
    },
    [types.GET_BALANCESHEET_REPORT](state, balancesheet) {
        state.balancesheet = balancesheet;
    },
    [types.GET_PROFIT_AND_LOSS_REPORT](state, profitandloss) {
        state.profitandloss = profitandloss;
    },
    [types.GET_TRIAL_BALANCE_REPORT](state, trialBalance) {
        state.trialBalance = trialBalance;
    },
    [types.GET_TDS_REPORT](state, tds) {
        state.tds = tds;
    },
    [types.GET_VATRETURN_REPORT](state, vatreturn) {
        state.vatreturn = vatreturn;
    },
    [types.GET_CASHBOOK_REPORT](state, cashbook) {
        state.cashbook = cashbook;
    },
    [types.GET_PAYROLL_VARIANCE_REPORT](state, payrollVariance) {
        state.payrollVariance = payrollVariance;
    },
    [types.GET_COMPLAINT_RESOLUTION_TIME_REPORT](state, complaintResolutionTime) {
        state.complaintResolutionTime = complaintResolutionTime;
    },
    [types.GET_STAFF_COMPLAINT_HANDLING_PERFORMANCE](state, staffComplaintHandlingPerformance) {
        state.staffComplaintHandlingPerformance = staffComplaintHandlingPerformance;
    },
    [types.GET_CUSTOMER_COMPLAINT_FREQUENCY](state, customerComplaintFrequency) {
        state.customerComplaintFrequency = customerComplaintFrequency;
    },
    [types.GET_LEAD_CLIENT_OPPORTUNITY_COST_SUMMARY](state, leadClientOpportunityCostSummary) {
        state.leadClientOpportunityCostSummary = leadClientOpportunityCostSummary;
    },
    [types.GET_CUSTOMER_TICKET_VOLUME_ANALYSIS](state, customerTicketVolumeAnalysis) {
        state.customerTicketVolumeAnalysis = customerTicketVolumeAnalysis;
    },
    [types.GET_SALES_SUMMARY_REPORT](state, salesSummaryReport) {
        state.salesSummaryReport = salesSummaryReport;
    },
    [types.GET_SALES_ANALYTICS_REPORT](state, salesAnalyticsReport) {
        state.salesAnalyticsReport = salesAnalyticsReport;
    },
    [types.GET_SALES_ANALYTICS_REPORT_BY_PRODUCT](state, salesAnalyticsReportByProduct) {
        state.salesAnalyticsReportByProduct = salesAnalyticsReportByProduct;
    },
    [types.GET_SALES_ANALYTICS_REPORT_BY_CLIENT](state, salesAnalyticsReportByClient) {
        state.salesAnalyticsReportByClient = salesAnalyticsReportByClient;
    },
    [types.GET_TICKET_CATEGORY_REPORT](state, ticketCategoryReport) {
        state.ticketCategoryReport = ticketCategoryReport;
    },
    [types.GET_QUOTATION_PRIORITY_REPORT](state, quotationPriorityReport) {
        state.quotationPriorityReport = quotationPriorityReport;
    },
    [types.GET_GENERALLEDGER_REPORT](state, generalLedger) {
        state.generalLedger = generalLedger;
    },
    [types.GET_Sales_Value_Contribution_by_Salesperson](state, SalesValueContributionBySalesperson) {
        state.SalesValueContributionBySalesperson = SalesValueContributionBySalesperson;
    }, 
    [types.GET_Lead_Aging_Analysis](state, LeadAgingAnalysis) {
        state.LeadAgingAnalysis = LeadAgingAnalysis;
    },
    [types.GET_PRODUCTION_COST_ANALYSIS_REPORT](state, productionCostAnalysisReport) {
        state.productionCostAnalysisReport = productionCostAnalysisReport;
    },
    [types.GET_PRODUCTION_REPORT](state, productionReport) {
        state.productionReport = productionReport;
    },
    [types.GET_PRODUCTION_LEAD_TIME_ANALYSIS_REPORT](state, productionLeadTimeAnalysisReport) {
        state.productionLeadTimeAnalysisReport = productionLeadTimeAnalysisReport;
    },
    [types.GET_PROJECT_COST_ANALYSIS_REPORT](state, projectCostAnalysisReport) {
        state.projectCostAnalysisReport = projectCostAnalysisReport;
    },
    [types.GET_PROJECT_STATUS_REPORT](state, projectStatusReport) {
        state.projectStatusReport = projectStatusReport;
    },
    [types.GET_INVENTORY_VALUE_ANALYSIS_REPORT](state, inventoryValueAnalysisReport) {
        state.inventoryValueAnalysisReport = inventoryValueAnalysisReport;
    },
    [types.GET_INVENTORY_QTY_ANALYSIS_REPORT](state, inventoryQtyAnalysisReport) {
        state.inventoryQtyAnalysisReport = inventoryQtyAnalysisReport;
    },
    [types.GET_WAREHOUSE_DISTRIBUTION_REPORT](state, warehouseDistributionReport) {
        state.warehouseDistributionReport = warehouseDistributionReport;
    },
    [types.GET_MONTHLY_SPENDING_BY_PLATFORM](state, monthlySpendingByPlatform) {
        state.monthlySpendingByPlatform = monthlySpendingByPlatform;
    },
};

export default mutations;